import React from 'react';

import { useClaim } from '~/components/ClaimContainer';
import { getSubOrganizationId } from '~/Utils/ClaimUtils';

import { useCliveClaimContext } from '../SystemConfiguration/CliveConfiguration/CliveClaimContext';

import CommunicationTabV3Wrapper from './CommunicationsTabV3';

const CommunicationsTab: React.FC<{ isTabActive?: boolean }> = ({ isTabActive = true }) => {
  const { isCliveEnabled } = useCliveClaimContext();
  const { claim } = useClaim({ claimRequired: true });
  const subOrganizationId = getSubOrganizationId(claim);
  const showClive = isCliveEnabled(subOrganizationId);

  return <CommunicationTabV3Wrapper isTabActive={isTabActive} showClive={showClive} />;
};

export default CommunicationsTab;
